import React from 'react'

import { useOpenChats } from '~components/whiteboard/open-chats-provider'
import { useOpenTeamChats } from './open-team-chats-provider'
import TeamChatPopover from './team-chat-popover'

/**
 * Renders popped-out team chats at the layout root so they persist across
 * pages. Stacks to the left of any open client-chat popovers.
 */
export default function TeamChatPopovers() {
    const { openTeamChatIds } = useOpenTeamChats()
    const { openChatIds } = useOpenChats()

    if (!openTeamChatIds.length) return null

    return (
        <>
            {openTeamChatIds.map((chatId, index) => (
                <TeamChatPopover
                    key={chatId}
                    chatId={chatId}
                    stackIndex={index + openChatIds.length}
                />
            ))}
        </>
    )
}
